// dialog2Reducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  historyList: [],
  historyListItemSelected: 0,
  historyBookChapter: { book: 0, chapter: 0 },
};

const dialog2Slice = createSlice({
  name: 'dialog2',
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setHistoryList(state, action) {
      state.historyList = action.payload;
    },
    setHistoryListItemSelected(state, action) {
      state.historyListItemSelected = action.payload;
    },
    setHistoryBookChapter(state, action) {
      state.historyBookChapter = action.payload;
    },
    reset4Dialog2() {
      return initialState;
    },
  },
});

export const { setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, reset4Dialog2 } = dialog2Slice.actions;
export default dialog2Slice.reducer;
// const initialState = {
//   loading: false,
//   historyList: [],
//   historyListItemSelected: 0,
//   historyBookChapter: { book: 0, chapter: 0 }
// };

// export default function dialog2Reducer(state = initialState, action) {
//   switch (action.type) {
//     case 'setLoading':
//       return {
//         ...state,
//         loading: action.payload,
//       };
//     case 'setHistoryList':
//       return {
//         ...state,
//         historyList: action.payload,
//       };          
//     case 'setHistoryListItemSelected':
//       return {
//         ...state,
//         historyListItemSelected: action.payload,
//       };
//     case 'setHistoryBookChapter':
//       return {
//         ...state,
//         historyBookChapter: action.payload,
//       };
//     case 'reset4Dialog2':
//       return initialState;          
//     default:
//       return state;
//   }
// }

// export const setLoading = (e) => ({
//   type: 'setLoading',
//   payload: e,
// });

// export const setHistoryList = (e) => ({
//   type: 'setHistoryList',
//   payload: e,
// });

// export const setHistoryListItemSelected = (e) => ({
//   type: 'setHistoryListItemSelected',
//   payload: e,
// });

// export const setHistoryBookChapter = (e) => ({
//   type: 'setHistoryBookChapter',
//   payload: e,
// });

// export const reset4Dialog2  = (e) => ({
//   type: 'reset4Dialog2',
//   payload: e,
// });